module.exports = __webpack_public_path__ + "static/media/coding-quiz.71ca72a2.png";